<div class="collapsible">
    <button class="collapsible-title"
            type="button"
            (click)="toggle()"
            [attr.aria-expanded]="open"
            [style.font-size]="titleFontSize"
            [style.background]="titleBackgroundColor"
            [style.font-weight]="titleFontWeight">
      <span class="indicator">{{ open ? '▼' : '▶' }}</span>
      <span class="title-text">{{ title }}</span>
    </button>

  <div *ngIf="open" class="collapsible-content"
       [style.margin-left]="contentLeftMargin">
    <ng-content></ng-content>
  </div>
</div>